import { defineStore } from "pinia";

import { resolveActiveConfirmationSettings } from "@/services/confirmationSettings";
import { applyConfirmationLayoutClass } from "@/services/confirmationLayout";

export const useConfirmationContextStore = defineStore("confirmationContext", {
  state: () => ({
    hasExtrasellOffers: false,
    stepType: null,
    step: 0,
    parentChoiceId: null,
    orderPageItemId: null,
    resolved: false,
  }),
  getters: {
    activeSettings(state) {
      return resolveActiveConfirmationSettings({
        hasExtrasellOffers: state.hasExtrasellOffers,
        stepType: state.stepType,
        step: state.step,
        parentChoiceId: state.parentChoiceId,
        orderPageItemId: state.orderPageItemId,
      });
    },
  },
  actions: {
    setContext(payload = {}) {
      this.hasExtrasellOffers = payload.hasExtrasellOffers === true;
      this.stepType = payload.stepType ?? null;
      this.step = Number.isFinite(Number(payload.step))
        ? Number(payload.step)
        : 0;
      this.parentChoiceId = payload.parentChoiceId ?? null;
      this.orderPageItemId = payload.orderPageItemId ?? null;
      this.resolved = true;
      applyConfirmationLayoutClass(
        this.activeSettings,
        this.hasExtrasellOffers,
      );
    },
    resetLayoutClass() {
      applyConfirmationLayoutClass({ recapPosition: "top" }, false);
    },
  },
});
